import React, { useState } from "react";
import TemplateListing from "./TemplateListing";
import TemplateCreation from "./TemplateCreation";

const Template = () => {
  const [showCreation, setShowCreation] = useState(false);

  return (
    <div className="p-3">
      {!showCreation ? (
        <TemplateListing onCreateNew={() => setShowCreation(true)} />
      ) : (
        <TemplateCreation onBack={() => setShowCreation(false)} />
      )}
    </div>
  );
};

export default Template;
